import { LitElement } from 'lit';

export type DispatchCustomEvent = {
  element: LitElement | Document | HTMLElement;
  eventName: string;
  detail?: CustomEvent['detail'];
  bubbles?: CustomEvent['bubbles'];
  /**
   * Pierces the Component's ShadowDom so it will land in the NormalDOM
   */
  composed?: CustomEvent['composed'];
  cancelable?: CustomEvent['cancelable'];
};

export const dispatchCustomEvent = ({
  element,
  eventName,
  detail,
  bubbles = true,
  composed = false,
  cancelable = false,
}: DispatchCustomEvent): CustomEvent => {
  const event = new CustomEvent(eventName, {
    detail,
    bubbles,
    composed,
    cancelable,
  });
  element.dispatchEvent(event);

  return event;
};

/**
 * Return if an Event contains a key code of given key(s).
 */
export const isKeydown = (event: Event, ...keys: Array<string>) => {
  return keys.includes((event as KeyboardEvent).code);
};

export type ListenHandle = {
  release(): null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Listen(element: any, ...args: any): ListenHandle {
  element.addEventListener(...args);
  return {
    release() {
      element.removeEventListener(...args);
      return null;
    },
  };
}
